var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33334 4.58358H5.50001C5.01377 4.58358 4.54746 4.77673 4.20364 5.12055C3.85983 5.46436 3.66667 5.93068 3.66667 6.41691V17.4169C3.66667 17.9031 3.85983 18.3695 4.20364 18.7133C4.54746 19.0571 5.01377 19.2502 5.50001 19.2502H10.7223M7.33334 4.58358C7.33334 4.09735 7.52649 3.63103 7.87031 3.28721C8.21413 2.9434 8.68044 2.75024 9.16667 2.75024H11C11.4862 2.75024 11.9526 2.9434 12.2964 3.28721C12.6402 3.63103 12.8333 4.09735 12.8333 4.58358M7.33334 4.58358C7.33334 5.06981 7.52649 5.53612 7.87031 5.87994C8.21413 6.22376 8.68044 6.41691 9.16667 6.41691H11C11.4862 6.41691 11.9526 6.22376 12.2964 5.87994C12.6402 5.53612 12.8333 5.06981 12.8333 4.58358M16.5 11.0002V6.41691C16.5 5.93068 16.3068 5.46436 15.963 5.12055C15.6192 4.77673 15.1529 4.58358 14.6667 4.58358H12.8333M7.33334 10.0836H11M7.33334 13.7502H10.0833M16.9583 17.8752L19.25 20.1669M12.8333 16.0419C12.8333 16.6497 13.0748 17.2326 13.5046 17.6624C13.9343 18.0921 14.5172 18.3336 15.125 18.3336C15.7328 18.3336 16.3157 18.0921 16.7455 17.6624C17.1752 17.2326 17.4167 16.6497 17.4167 16.0419C17.4167 15.4341 17.1752 14.8512 16.7455 14.4215C16.3157 13.9917 15.7328 13.7502 15.125 13.7502C14.5172 13.7502 13.9343 13.9917 13.5046 14.4215C13.0748 14.8512 12.8333 15.4341 12.8333 16.0419Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSearch);
export default __webpack_public_path__ + "static/media/report-search.472c23b417f6705ea73690de000785ee.svg";
export { ForwardRef as ReactComponent };